import { render, staticRenderFns } from "./ViewerVideo.vue?vue&type=template&id=ecaca1aa&scoped=true&"
import script from "./ViewerVideo.vue?vue&type=script&lang=js&"
export * from "./ViewerVideo.vue?vue&type=script&lang=js&"
import style0 from "./ViewerVideo.vue?vue&type=style&index=0&id=ecaca1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecaca1aa",
  null
  
)

export default component.exports